import Alpine from 'alpinejs'
import header from '@/components/header.js'
import language from '@/components/language.js'
import video from '@/components/video.js'
import accordion from '@/components/accordion.js'
import embedVideo from '@/components/embed/video.js'
import { fundChart } from '@/components/funds.js';

//
// Styles
//
import '../css/style.css'

//
// Setup Alpine
//
window.Alpine = Alpine

//
// Setup Alpine components
//
Alpine.data('header', header)
Alpine.data('language', language)
Alpine.data('video', video)
Alpine.data('accordion', accordion)
Alpine.data('embedVideo', embedVideo)
Alpine.data('fundChart', fundChart)

//
// Initialize Alpine
//
Alpine.start()

//
// Staggered appear animations
//
const staggers = [...document.querySelectorAll('[data-stagger]')]
const onIntersecting = (target) => {
    const items = [...target.querySelectorAll('[data-appear]')]

    items.forEach((item, index) => {
        const className = item.dataset.appear
        const delay = (parseInt(item.dataset.appearDelay) || 0) + index * 100
        const onAnimationEnd = (event) => {
            event.target.classList.remove(className)
            event.target.removeAttribute('data-appear')
            event.target.removeEventListener('animationend', onAnimationEnd)
        }

        item.addEventListener('animationend', onAnimationEnd)
        item.style.animationDelay = `${delay}ms`
        item.classList.add(className)
    })
}
const observer = !!window.IntersectionObserver
    ? new IntersectionObserver(
          (entries, observer) => {
              for (const entry of entries) {
                  if (entry.intersectionRatio > 0) {
                      onIntersecting(entry.target)
                      observer.unobserve(entry.target)
                  }
              }
          },
          {
              rootMargin: '0% 0% -40% 0%',
              threshold: 0,
          }
      )
    : null

staggers.forEach((stagger) => {
    if (observer) {
        observer.observe(stagger)
    } else {
        onIntersecting(stagger)
    }
})
